import { render, staticRenderFns } from "./TextAreaHTMLField.vue?vue&type=template&id=65191f8a&scoped=true"
import script from "./TextAreaHTMLField.vue?vue&type=script&lang=js"
export * from "./TextAreaHTMLField.vue?vue&type=script&lang=js"
import style0 from "./TextAreaHTMLField.vue?vue&type=style&index=0&id=65191f8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65191f8a",
  null
  
)

export default component.exports